import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import * as _ from "lodash";
import {Equipment} from "@models/equipment.model";

@Component({
    selector: 'app-equipment-form',
    templateUrl: './equipment-form.component.html',
    styleUrls: ['./equipment-form.component.scss']
})
export class EquipmentFormComponent implements OnInit {

    @Input() selectedEquipment: Equipment[];
    @Input() availableEquipment: Equipment[];
    @Input() showValidations = false;

    equipmentForm: UntypedFormGroup;

    static notEmpty(control: UntypedFormControl): { [s: string]: boolean } {
        if (control.value && !(control.value.length > 0)) {
            return {'picklist.atLeastOne': true};
        }
        return null;
    }

    constructor() {
    }

    ngOnInit() {
        this.equipmentForm = new UntypedFormGroup({
            selectedEquipment: new UntypedFormControl(this.selectedEquipment, [EquipmentFormComponent.notEmpty]),
        });
    }

    isFormValid() {
        return this.equipmentForm.valid;
    }

    reset() {
        this.equipmentForm.reset();
    }

    value() {
        return {equipmentIds: _.map(this.equipmentForm.controls.selectedEquipment.value, 'id')};
    }

}
